<agpr-take-over-panel
    [id]="id"
    class="agpr-drilldown"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    (visibleChange)="close($event)"
    [width]="100"
    [hasSideTabs]="true"
    [noScroll]="true"
    invisibleHeader="Reports.chartDrillDownDialog.title"
>
    <ng-template #noScrollContent>
        <div
            class="agpr-drilldown-section"
            [agprLoading]="loading$ | async"
        >
            <div class="agpr-drilldown-sectionLeft">
                <div class="agpr-drilldown-header">
                    <agpr-card-chart
                        class="agpr-viSummary-card--column"
                        [series]="cardSeries"
                        [color]="cardColor"
                        [layout]="cardChartLayoutType.horizontal"
                        bubbleTooltipSubjectLocalizationString="Monitor.cardCharts.bubbleTooltipSubject"
                        [bubbleTooltipMetric]="chartType"
                        [headingLevel]="4"
                        [label]="chartLabel"
                        [numberOfDecimals]="numberOfDecimals"
                        [isPercentage]="percentageCharts.includes(chartType)"
                    ></agpr-card-chart>

                    <div class="agpr-drilldown-headerToolbar">
                        <agpr-vi-date-picker
                            [id]="id + '_startInput'"
                            class="agpr-drilldown-headerToolbar-datePicker"
                            [mostRecentDate]="mostRecentDate"
                            [availableDates]="dayOptions"
                            [ariaLabelledBy]="id + '_startDateLabel'"
                            [(ngModel)]="selectedDate"
                            (ngModelChange)="dateChanged()"
                        ></agpr-vi-date-picker>
                        <agpr-button
                            [id]="id + '_viewModeBtn'"
                            class="agpr-drilldown-headerToolbar-viewList"
                            [style]="buttonType.iconFilled"
                            [icon]="viewMode === viewModeType.GROUP ? 'fa-solid fa-list' : 'fa-solid fa-list-tree'"
                            [tooltip]="viewMode === viewModeType.GROUP ? 'Vi.viewList' : 'Vi.viewGroups'"
                            tooltipPosition="top"
                            (click)="changeViewMode()"
                        ></agpr-button>
                        <agpr-sort-order
                            [id]="id + '_sortOrder'"
                            class="agpr-drilldown-headerToolbar-sort"
                            tooltip="Vi.tooltips.sortResults"
                            optionKey="enumValue"
                            optionLabel="displayString"
                        ></agpr-sort-order>
                        <agpr-icon-dropdown
                            [id]="id + '_visibilityDropdown'"
                            displayIcon="fa-regular fa-duotone fa-eye"
                            [options]="visibilityOptions"
                            [applyHighlight]="true"
                            [(ngModel)]="selectedVisibilityOption"
                            (ngModelChange)="visibilityChanged()"
                            inputTooltip="Vi.visiblitySettings.tooltip"
                            ariaLabel="Vi.visiblitySettings.tooltip"
                        ></agpr-icon-dropdown>
                    </div>
                </div>

                <agpr-scroll-panel class="agpr-drilldown-scrollPanel">
                    <ul
                        [id]="id + '_resultList'"
                        class="agpr-drilldown-scrollPanelList"
                    >
                        @if (viewMode === viewModeType.GROUP) {
                            @for (card of filterDimensionCards; track card.dimension) {
                                <li
                                    [id]="id + '_resultItem'"
                                    tabindex="0"
                                >
                                    <agpr-vi-dimension-card
                                        [card]="card"
                                        [selectedQuestion]="selectedQuestion"
                                        [inverseArrows]="chartType === viChartTypeEnums.RANK_WHEN_LISTED"
                                        [allowDelete]="false"
                                        [interactive]="false"
                                        [showMetrics]="true"
                                        (questionSelected)="focusQuestion($event)"
                                    ></agpr-vi-dimension-card>
                                </li>
                            }
                        } @else if (viewMode === viewModeType.LIST) {
                            @for (result of filterResults; track result.id; let i = $index) {
                                <li
                                    [id]="id + '_resultItem'"
                                    tabindex="0"
                                >
                                    <agpr-vi-question-card
                                        [id]="id + '_question_' + i"
                                        [question]="result.question"
                                        [allowDelete]="false"
                                        [selected]="isSelected(result)"
                                        [showDimention]="true"
                                        [inverseArrows]="chartType === viChartTypeEnums.RANK_WHEN_LISTED"
                                        [dimension]="result.dimension"
                                        [showMetrics]="true"
                                        [score]="result.score"
                                        [delta]="result.delta"
                                        (selectChange)="focusQuestion(result)"
                                    ></agpr-vi-question-card>
                                </li>
                            }
                        }
                    </ul>
                </agpr-scroll-panel>
            </div>
            <div class="agpr-drilldown-sectionRight">
                <agpr-right-sidebar class="agpr-drilldown-rhp">
                    <agpr-tab
                        [id]="id + '_answersTab'"
                        class="agpr-drilldown-answersTab"
                        icon="fa-solid fa-message-lines"
                        tooltip="Vi.qnA.tab.answers"
                        heading="Vi.qnA.tab.answers"
                    >
                        <agpr-vi-answer-panel
                            [engines]="answerEngineOptions"
                            [(selectedType)]="selectedEngineType"
                        ></agpr-vi-answer-panel>
                    </agpr-tab>

                    <agpr-tab
                        [id]="id + '_answerScoresTab'"
                        class="agpr-drilldown-answerScoresTab"
                        icon="fa-duotone fa-solid fa-bars-progress"
                        tooltip="Vi.qnA.tab.answerScore"
                        heading="Vi.qnA.tab.answerScore"
                    >
                        <agpr-vi-answer-scores
                            [id]="id + '_answerScores'"
                            [engines]="answerEngineOptions"
                            [previousEngines]="previousAnswerEngineOptions"
                            [ownDomains]="brand.websites ?? []"
                        ></agpr-vi-answer-scores>
                    </agpr-tab>

                    <agpr-vi-insights-tab
                        [id]="id + '_insightsTab'"
                        class="agpr-drilldown-insightsTab"
                        [initialViBrand]="brand"
                        [answerEngineTypes]="answerEngineOptions"
                        [prompts]="prompts"
                        [executedPrompt]="executedPrompt"
                        (langSelectionChanged)="selectedInsightsLanguage = $event"
                    ></agpr-vi-insights-tab>

                    <agpr-vi-source-outlets-tab
                        [id]="id + '_outletsTab'"
                        class="agpr-drilldown-sourceOutletsTab"
                        [outletList]="outletList"
                        [loading]="outletListLoading"
                    ></agpr-vi-source-outlets-tab>
                </agpr-right-sidebar>
            </div>
        </div>
    </ng-template>

    <ng-template #takeOverFooterRight>
        <agpr-button
            [id]="id + '_doneBtn'"
            [style]="buttonType.primary"
            label="done"
            (click)="close(false)"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
